<template>
    <div class="the-data-card">
        <ul>
            <li v-for="(item, key) in value" :key="key"
                v-if="filterArr.indexOf(key)=== -1"
                class=" border-bottom">
                <div class="title-text overflow-hidden-1" :title="key">
                    <p :title="key" class="title">{{key}}</p>
                    <p>:</p>
                </div>
                <span :title="item ||'To upgrade' ">{{item || 'To upgrade'}}</span>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  name: 'theDataCard',
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      filterArr: ['name', '权重', '置信度']
    }
  }
}
</script>

<style scoped lang="scss">
    .the-data-card {
        padding: 0 25px;
        overflow-y: scroll;

        .title-text {
            display: flex !important;
            align-items: center;
            color: #aaaaaa;

            .title {
                max-width: calc(100% - 10px);
                padding: 0 2px 0 0 !important;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        ul {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        }

        li {
            width: 50%;
            padding: 5px 0;
            display: flex;
            align-items: center;

            &:nth-last-child(1), &:nth-last-child(2) {
                border-bottom: none !important;
            }
        }
    }
</style>
